import httpService from "./http.service";

const cafeEndpoint = "cafes/";

const cafeService = {
  get: async (payload) => {
    const { data } = await httpService.get(cafeEndpoint, {
      params: payload, // <-- сюда кладём town и другие query
    });
    return data;
  },
};
export default cafeService;
